import _ from "lodash";

import * as Utils from "./utils";

export function cloneDeep(obj) {
	let result = null;
	try {
		result = JSON.parse(JSON.stringify(obj));
	} catch (e) {
		console.error(e);
		result = _.cloneDeep(obj);
	}

	return result;
}

export function getNumberOfInstancesNotSynced(tree) {
	let instances = tree.get(["instances"]);
	let count = 0;

	for (let prop in instances) {
		let checklistId = prop;
		let checklistInstances = instances[prop];

		if (Utils.isInChecklists(tree, checklistId)) {
			for (let i = 0; i < checklistInstances.length; i++) {
				let trackData = true;
				if (checklistInstances[i].hasOwnProperty("trackData") && !checklistInstances[i].trackData) {
					trackData = false;
				}
		
				if (trackData && !checklistInstances[i].sync) {
					count++;
				}
			}
		}
	}

	return count;
}

export function isValidLinkAction(linkActionType, linkId) {
	let isValidLinkAction = false;

	linkActionType = linkActionType.toLowerCase();

	if (
		linkActionType.startsWith("resetcurrentchecklist") ||
		linkActionType.startsWith("resetcurrentactivity") ||
		linkActionType.startsWith("resetcurrentlist") ||
		linkActionType.startsWith("resetcurrentsection") ||
		linkActionType.startsWith("saveactivityandexit") ||
		linkActionType.startsWith("opencomments") ||
		linkActionType.startsWith("opennotes") ||
		linkActionType.startsWith("openmedia") ||
		linkActionType.startsWith("opensketchpad") ||
		linkActionType.startsWith("goback")
	) {
		isValidLinkAction = true;
	} else if (
		linkActionType.startsWith("external") ||
		linkActionType.startsWith("openitemmodal") ||
		linkActionType.startsWith("showmodalitem") ||
		linkActionType.startsWith("goto") ||
		linkActionType.startsWith("newsessionandgoto") ||
		linkActionType.startsWith("gotoandreturn") ||
		linkActionType.startsWith("newsessionandgotoandreturn") ||
		linkActionType.startsWith("resetrangeandgoto")
	) {
		if (linkId !== "") {
			isValidLinkAction = true;
		}
	}

	return isValidLinkAction;
}

export function linkActionNavigates(linkActionType) {
	let linkActionNavigates = false;

	if (
		linkActionType.startsWith("external") ||
		linkActionType.startsWith("goto") ||
		linkActionType.startsWith("newsessionandgoto") ||
		linkActionType.startsWith("gotoandreturn") ||
		linkActionType.startsWith("newsessionandgotoandreturn") ||
		linkActionType.startsWith("resetrangeandgoto")
	) {
		linkActionNavigates = true;
	}

	return linkActionNavigates;
}

export function getLinkInfo(item, value) {
	if (item.type === "itemYesNo") {
		const linkOnSelect = (item.hasOwnProperty("yesNoLinkOnSelect") ? item.yesNoLinkOnSelect : false);
		const yesLinkId = (item.hasOwnProperty("yesNoYesLinkId") ? item.yesNoYesLinkId : "");
		const noLinkId = (item.hasOwnProperty("yesNoNoLinkId") ? item.yesNoNoLinkId : "");
		const naLinkId = (item.hasOwnProperty("yesNoNaLinkId") ? item.yesNoNaLinkId : "");
		const linkActionType = (item.hasOwnProperty("yesNoLinkActionType") ? item.yesNoLinkActionType : "goto");
	
		let linkId = "";
		let _linkActionType = item.yesNoLinkActionType;
		if (value === "yes") {
			let yesLinkActionType = (item.hasOwnProperty("yesLinkActionType") ? item.yesLinkActionType : linkActionType);
			if (yesLinkActionType === "inherit") {
				yesLinkActionType = _linkActionType;
			}
			_linkActionType = yesLinkActionType;
			linkId = yesLinkId;
		} else if (value === "no") {
			let noLinkActionType = (item.hasOwnProperty("noLinkActionType") ? item.noLinkActionType : linkActionType);
			if (noLinkActionType === "inherit") {
				noLinkActionType = _linkActionType;
			}
			_linkActionType = noLinkActionType;
			linkId = noLinkId
		} else if (value === "n/a") {
			let naLinkActionType = (item.hasOwnProperty("naLinkActionType") ? item.naLinkActionType : linkActionType);
			if (naLinkActionType === "inherit") {
				naLinkActionType = _linkActionType;
			}
			_linkActionType = naLinkActionType;
			linkId = naLinkId;
		}
	
		return {
			linkOnSelect: linkOnSelect,
			linkActionType: _linkActionType,
			yesLinkId: yesLinkId,
			noLinkId: noLinkId,
			naLinkId: naLinkId,
			linkId: linkId,
			isValidLinkAction: isValidLinkAction(_linkActionType, linkId),
			linkActionNavigates: linkActionNavigates(_linkActionType)
		};	
	} else if (item.type === "itemPicker") {
		let pickerLinkOnSelect = (item.hasOwnProperty("pickerLinkOnSelect") ? item.pickerLinkOnSelect : false);
		let pickerLinkId = "";
		let pickerLinkActionType = (item.hasOwnProperty("pickerLinkActionType") ? item.pickerLinkActionType : "goto");

		let pickerItem = _.find(item.pickerItems, function(o) {return o.value === value});
		
		if (pickerItem && pickerItem.hasOwnProperty("properties") && pickerItem.properties !== "") {
			let properties = pickerItem.properties;

			let propertiesObject = JSON.parse(properties);
			Object.assign(pickerItem, propertiesObject);

			pickerLinkOnSelect = true;

			const pickerItemParts = pickerItem.linking.split(":");

			if (pickerItemParts.length > 1) {
				pickerLinkActionType = pickerItemParts[0];
				pickerLinkId = pickerItemParts[1];
			} else {
				pickerLinkActionType = pickerItemParts[0];
			}
		} else if (pickerItem && pickerItem.hasOwnProperty("value")) {
			pickerLinkId = pickerItem.value;
		}

		return {
			linkOnSelect: pickerLinkOnSelect,
			linkActionType: pickerLinkActionType,
			linkId: pickerLinkId,
			isValidLinkAction: isValidLinkAction(pickerLinkActionType, pickerLinkId),
			linkActionNavigates: linkActionNavigates(pickerLinkActionType)
		};	
	} else {
		const itemLinkOnSelect = (item.hasOwnProperty("linkOnSelect") ? item.linkOnSelect : false);
		let itemLinkId = (item.hasOwnProperty("linkId") ? item.linkId : "");
		let itemLinkActionType = (item.hasOwnProperty("linkActionType") ? item.linkActionType : "goto");

		return {
			linkOnSelect: itemLinkOnSelect,
			linkActionType: itemLinkActionType,
			linkId: itemLinkId,
			isValidLinkAction: isValidLinkAction(itemLinkActionType, itemLinkId),
			linkActionNavigates: linkActionNavigates(itemLinkActionType)
		};
	}
}
